import React from "react";
import { Nav, Navbar } from "react-bootstrap";
import tabStyles from "../controls/tabs/TabsStyles.module.scss";
import styles from "./resourceInsights.module.scss";

/**
 * The tabs of Resource Insights, drawn the way the tabs of the overview pages (project, program, portfolio) are: a rounded
 * strip with the selected tab filled in the primary colour.
 *
 * @param tabs  `[{ value, label }]`
 */
export default function InsightsTabs({ tabs, selected, onSelect }) {
  return (
    <div className={`overviewTabsContainer ${tabStyles.tabScrollRow} ${styles.tabs}`}>
      <Navbar className={tabStyles.overviewTabWrapper}>
        <Nav className={`${tabStyles.overviewTabItemsWrap} nav-underline`}>
          {tabs.map((tab) => (
            <Nav.Link key={tab.value} className={`${tabStyles.overviewTabItem} ${selected === tab.value ? tabStyles.active : ""}`} onClick={() => onSelect(tab.value)}>
              {tab.label}
            </Nav.Link>
          ))}
        </Nav>
      </Navbar>
    </div>
  );
}
